import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ListLoader from "../../../CustomComponents/AllLoader/ListLoader";
import OrderPostPagination from "../../FindWork/SearchAll/AllPosts/CustomPagination/OrderPostPagination";
import { getRemaindays } from "../../../Common/AllDateTimeReleventFormate";
import { getMyOrderProjectList } from "../../../../redux/project/action";
import GetRemainDays from "../../MyOrders/MyOrders/PostedOrders/PostedProjects/MineActiveProject/ProjectModels/GetRemainDays";
import GetStatus from "../../MyOrders/MyOrders/PostedOrders/PostedProjects/MineActiveProject/ProjectModels/GetStatus";
import { decodeHtml } from "../../../../assests/extention/commonfunction";

export default function PaginationforProjectActive() {
  const path = "Assets/scss/myorders.module.scss";
  const laung = localStorage.getItem("laung");
  const [lan, setlan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const [pageNumber, setPageNumber] = useState(0);

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const myorderprojectlist = useSelector(
    ({ project: { myorderprojectlist } }) => myorderprojectlist,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getMyOrderProjectList(1, pageNumber, 10, 2));
  }, [pageNumber]);

  return (
    <div className="order-tabs">
      <div className="tab-content">
        <div className="posted-project">
          {Array.isArray(myorderprojectlist?.response) && (
            <>
              <h4>
                Active Post & Browse Projects (PBP)
                <OrderPostPagination
                  totalitemcounts={myorderprojectlist?.count}
                  size={10}
                  pageNumber={pageNumber}
                  setPageNumber={setPageNumber}
                />
              </h4>
              {myorderprojectlist?.length == 0 && <ListLoader />}
              <div className="recent-post">
                {myorderprojectlist?.response.map((item, index) => (
                  <div key={index} className="post-back">
                    <div className="col-md-5">
                      <h3>{decodeHtml(item.title)}</h3>
                      <div className="post-img">
                        <GetRemainDays
                          enddate={item?.active_milestone?.ends_on}
                        />
                      </div>
                    </div>
                    <div className="activity col-md-4">
                      <h6>Active milestone: {item?.active_milestone_count}</h6>
                      <h5>
                        {!item?.active_milestone?.title
                          ? "No Active Milestone"
                          : decodeHtml(item?.active_milestone?.title)}
                      </h5>

                      <GetStatus status={item?.active_milestone?.status} />
                    </div>
                    <button
                      onClick={() =>
                        navigate(
                          `/${lan}/dashboard/myorders/project/active/${item.id}`,
                        )
                      }
                      className="btn"
                    >
                      Review works
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                        alt=""
                      />
                    </button>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
